export default __webpack_public_path__ + "static/media/microsoft--white.6807a264.svg";